<template>
  <b-container>
    <WizardPageTitle title="Authentication" />
    <b-row>
      <b-col>
        <b-form>
          <b-form-group description="Enable this if your service will have users signing in">
            <b-form-checkbox v-model="enableAuth">
              Enable authentication
            </b-form-checkbox>
          </b-form-group>
          <div v-if="enableAuth">
            <b-form-group
              label="Token type"
              description="Type of token to use for authentication"
            >
              <b-form-select
                v-model="tokenType"
                :options="tokenChoices"
              />
            </b-form-group>
            <b-form-group
              v-if="tokenType === 'jwt'"
              label="JWT validity (minutes)"
              description="For how long the JWT is valid until it needs to be refreshed
                (in minutes)"
            >
              <b-form-input
                v-model="jwtDuration"
                number
                type="number"
                :min="MIN_JWT_DURATION"
                :max="MAX_JWT_DURATION"
              >
                5
              </b-form-input>
            </b-form-group>
            <b-form-group description="Allow new users to sign up (create account) using the API">
              <b-form-checkbox v-model="allowSignup">
                Allow new user signup
              </b-form-checkbox>
            </b-form-group>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <WizardPrevNext />
  </b-container>
</template>

<style lang="scss" scoped>
h2 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>

<script>
import WizardPageTitle from './widgets/WizardPageTitle.vue';
import WizardPrevNext from './widgets/WizardPrevNext.vue';
import navigationMixin from './mixins/navigation';

export default {
  name: 'Auth',
  components: {
    WizardPageTitle,
    WizardPrevNext,
  },
  mixins: [navigationMixin],
  data() {
    const { auth } = this.$store.state.recipe;

    return {
      enableAuth: !!auth,
      allowSignup: auth && auth.allow_signup,
      tokenType: auth ? auth.token : 'simple',
      jwtDuration: auth ? auth.tokenDuration : 5,
    };
  },
  computed: {
    tokenChoices() {
      return [
        { value: 'simple', text: 'Simple opaque bearer token' },
        // JWT is not implemented - let's hope we never have to implement that
        // { value: 'jwt', text: 'JSON Web Token (JWT)' },
      ];
    },
    MIN_JWT_DURATION: () => 5, // 5 minutes
    MAX_JWT_DURATION: () => 24 * 60, // one day
  },
  methods: {
    commit() {
      if (!this.enableAuth) {
        this.$store.commit('updateRecipe', { auth: null });
      } else {
        const tokenDuration = Math.min(
          this.MAX_JWT_DURATION,
          Math.max(
            this.MIN_JWT_DURATION,
            this.jwtDuration,
          ),
        );

        this.$store.commit('updateRecipe', {
          auth: {
            allow_signup: !!this.allowSignup,
            token: this.tokenType,
            tokenDuration,
          },
        });
      }
      return true;
    },
  },
};
</script>
